<script>
import { healthRecordService } from '@services/HealthRecordService'
import capitalizeFirstLetter from '@utils/capitalize-first-letter.js'
import HrActions from '@components/hr-actions.vue'
import SpeechToText from '@components/speech-to-text.vue'
import FileUpload from '@components/file-upload.vue'
import AttachmentList from '@components/attachment-list.vue'
import ForMyEyesOnly from '@components/for-my-eyes-only.vue'
import { constants } from '@src/constants'
export default {
  components: {
    SpeechToText,
    FileUpload,
    HrActions,
    AttachmentList,
    ForMyEyesOnly,
  },
  data() {
    return {
      medicalDatePickerName: '',
      tryingToSave: false,
      tryingToDelete: false,
      dateError: null,
      message: false,
      hasResponse: false,
      isAnother: false,
      isContinue: false,
      confirmDialog: false,
    }
  },
  computed: {
    headerType() {
      if (this.show) {
        return 'show'
      }
      if (this.edit) {
        return 'edit'
      }
      return ''
    },
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
    },
    computedMessage() {
      return `Are you sure you want to delete
        ${this.item.record_type_label}
        ( ${this.item.label} ) ?`
    },
  },
  methods: {
    clearErrors(eventName, formName, modelError = null) {
      if (Object.prototype.hasOwnProperty.call(this.$data, 'dateError')) {
        this.dateError = null
      }

      this.clearFormFromErrors(
        event,
        formName,
        // eslint-disable-next-line vue/comma-dangle
        modelError
      )
    },
    clearFormFromErrors(eventName, formName, modelError = null) {
      if (
        Object.prototype.hasOwnProperty.call(this.$data, formName) &&
        Object.prototype.hasOwnProperty.call(this[formName], 'errors') &&
        Object.prototype.hasOwnProperty.call(
          this[formName].errors.errors,
          eventName
        )
      ) {
        this[formName].errors.clear(eventName)
      }

      if (modelError) {
        this[modelError] = null
      }
    },
    showMedicalDate(fieldName) {
      if (fieldName) {
        this.medicalDatePickerName = fieldName
      }
    },
    editItem(id, resource, item) {
      this.$router.push({
        name: 'health-record-edit',
        params: {
          id: id,
          resource: resource,
          item: item,
        },
      })
    },
    getConstantResource() {
      if (
        Object.prototype.hasOwnProperty.call(
          constants.healthRecordModels,
          this.resource
        )
      ) {
        const model = constants.healthRecordModels[this.resource]
        const resource = constants.healthRecord[model].resource
        return resource
      }
      return ''
    },
    async deleteItem() {
      try {
        this.tryingToDelete = true
        const deleteResponse = await healthRecordService.delete(this.item.hr_id)

        if (deleteResponse.status === 200) {
          this.confirmDialog = false
          this.$emit('delete-from-hr', this.getConstantResource())
          this.$emit('close-dialog')
          document.getElementById('getAllData').click()
        }
      } catch (error) {
        console.warn(error)
      } finally {
        this.tryingToDelete = false
      }
    },
    closeItem() {
      this.$router.push({ name: 'health-record' })
    },
    getDeletedAttachments() {
      const result = []
      const attachmentsField = this.getAttachmentsField()
      const originalAttachmentsField = this.getOriginalAttachmentsField()

      this[originalAttachmentsField].forEach((x) => {
        let found = null
        if (this[attachmentsField].length > 0) {
          found = this[attachmentsField].find((element) => element.id === x.id)
        }
        if (found === undefined || found === null) {
          result.push(x.id)
        }
      })

      return result
    },
    getNewAttachments() {
      const result = []
      const attachmentsField = this.getAttachmentsField()
      const originalAttachmentsField = this.getOriginalAttachmentsField()

      this[attachmentsField].forEach((x) => {
        let found = null
        if (this[originalAttachmentsField].length > 0) {
          found = this[originalAttachmentsField].find(
            (element) => element.id === x.id
          )
        }
        if (found === undefined || found === null) {
          result.push(x)
        }
      })

      return result
    },
    getAttachmentsField() {
      if (Object.prototype.hasOwnProperty.call(this.$data, 'row')) {
        if (this.row === 'Labs') {
          return 'labsAttachments'
        } else if (this.row === 'Imaging') {
          return 'imagingAttachments'
        } else {
          return this.row + 'Attachments'
        }
      }
      return 'attachments'
    },
    getOriginalAttachmentsField() {
      if (Object.prototype.hasOwnProperty.call(this.$data, 'row')) {
        return 'original' + capitalizeFirstLetter(this.row) + 'Attachments'
      }
      return 'originalAttachments'
    },
    determinePast(past, medicalDateObject) {
      if (past) {
        return 'past'
      } else {
        return medicalDateObject.part
      }
    },
    resetFlagsAndErrors(error, action) {
      this.tryingToSave = true
      this[error] = null
      this.dateError = null
      this.message = false
      this.hasResponse = false
      if (action === 'another') {
        this.isAnother = true
      }
      if (action === 'continue') {
        this.isContinue = true
      }
    },
    scrollToErrors() {
      this.$nextTick(() => {
        const target = document.querySelector('.error--text')
        this.$vuetify.goTo(target, {
          container: '#componentArea',
          duration: 800,
          easing: 'easeInOutCubic',
        })
      })
    },
    goBack() {
      this.$emit('back')
    },
    onDrop(event) {
      event.preventDefault()
      const attachmentsField = this.getAttachmentsField()
      if (event.dataTransfer.items) {
        for (let i = 0; i < event.dataTransfer.items.length; i++) {
          // If dropped items aren't files, reject them
          if (event.dataTransfer.items[i].kind === 'file') {
            const file = event.dataTransfer.items[i].getAsFile()
            this[attachmentsField].push(file)
          }
        }
      } else {
        // Use DataTransfer interface to access the file(s)
        for (let i = 0; i < event.dataTransfer.files.length; i++) {
          this[attachmentsField].push(event.dataTransfer.files[i])
        }
      }
    },
    prepareDeletion(item) {
      this.confirmDialog = true
    },
    cancel() {
      this.confirmDialog = false
    },
  },
}
</script>
